import request from '@/utils/request'

export function getVideoList(param) {
  return request({
    url: '/frontEnd/videoList',
    method: 'get',
    params: param
  })
}
export function getVideoCategory() {
  return request({
    url: '/frontEnd/videoCategory',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/index.js